<template>
	<AppDialog width="580px" height="480px" ref="dialog_container" dialogName="StudioModeRestrictedDialog" closeTop="4" closeRight="4">
		<div class="dialog-content-container">
			<div class="title-text text-align-left">Ply Studio is currently in closed beta</div>
			<div class="description-text mt-1">Studio lets you create your own features for your apps, without code.</div>
			<div class="video-container mb-4 mt-4">
				<iframe
					frameborder="0"
					allowfullscreen
					mozallowfullscreen
					webkitallowfullscreen
					style="border-radius: 10px"
					class="width-100 height-100"
					src="https://www.loom.com/embed/b622db2a22be465eaf9f76e3289892a2"
				/>
				<!-- TODO user mode: change link!! -->
			</div>
			<div class="width-100 flex-centerize mt-9">
				<AnemicButton @click="requestAccess" class="request-button">Request access</AnemicButton>
			</div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
export default {
	name: 'StudioModeRestrictedDialog',
	components: {
		AppDialog,
	},
	props: {},
	computed: {},
	methods: {
		close() {
			this.$refs.dialog_container.closeCurrentDialog();
		},
		requestAccess() {
			window.open(`https://ply.typeform.com/to/G6r5Tnk6`, '_blank');
		},
	},
};
</script>

<style scoped lang="scss">
.dialog-content-container {
	width: 580px !important;
	height: 480px !important;
	border-radius: 14px;
	background: var(--bg-color);
	padding: 28px 30px;
	box-shadow: 0px 3px 6px var(--shadow-color);
}

.video-container {
	width: 520px;
	height: 292px;
}
.title-text {
	font-weight: 400;
	font-size: 24px;
	line-height: 20px;
	color: #4d4c52;
}
.request-button {
	border-radius: 8px !important;
	background: var(--bold-border-color) !important;
	color: var(--bg-color);
	padding: 0px !important;
	width: 244px !important;
	height: 33px !important;
}
.description-text {
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #4d4c52;
}
</style>
